import { createClient } from '@supabase/supabase-js'

export const supabaseUrl = 'https://v160-251-74-46.6h8d.static.cnode.io:9000'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICJyb2xlIjogImFub24iLAogICJpc3MiOiAic3VwYWJhc2UiLAogICJpYXQiOiAxNzAzNDMwMDAwLAogICJleHAiOiAxODYxMjgyODAwCn0.mv64VLBm-vCjXEBRiSFcoy_TOmWhvC86GveCq5DtwOs'
export const supabase = createClient(supabaseUrl, supabaseAnonKey)